import { createContext, useState, useContext, useCallback } from "react";

import surveyTranslations from "../utils/surveyTranslations";

const SurveyLanguageContext = createContext(null);

export const SurveyLanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");

  const translate = useCallback(
    (key, params) => {
      const langStrings = surveyTranslations[language] || surveyTranslations.en;
      const value = langStrings[key] || surveyTranslations.en[key] || key;

      if (typeof value === "function") {
        return value(params || {});
      }

      return value;
    },
    [language]
  );

  return (
    <SurveyLanguageContext.Provider
      value={{ language, setLanguage, translate }}
    >
      {children}
    </SurveyLanguageContext.Provider>
  );
};

export const useSurveyLanguage = () => {
  const context = useContext(SurveyLanguageContext);

  if (!context) {
    return {
      language: "en",
      setLanguage: () => {},
      translate: (key, params) => {
        const value = surveyTranslations.en[key] || key;

        if (typeof value === "function") {
          return value(params || {});
        }

        return value;
      }
    };
  }

  return context;
};
